/*
 * @Author: stevensh
 * @Date: 2020-03-01 17:17:19
 * @Last Modified by: stevensh
 * @Last Modified time: 2020-06-08 19:05:21
 */

import jsonp from 'fetch-jsonp';
import { message } from 'antd';
import queryString from 'querystring';
import { getCookie, delCookie } from 'utils/cookie';
import axios from 'axios';
import env from '../env';

const Ajax = axios as any;

export const api_host = env[process.env.REACT_APP_SECRET_API].api_host;

export const shopify_host = env[process.env.REACT_APP_SECRET_API].shopify_host;

export const myAxios = axios.create({
  baseURL: api_host,
});

export const shopifyAxios = axios.create({
  baseURL: shopify_host,
});

myAxios.interceptors.request.use(e => {
  const token = getCookie('shopify-sino-accessToken');
  if (token) {
    e.headers['X-Sino-Token'] = token;
  } else {
    // message.error('token已失效');
    delCookie('shopify-sino-accessToken');
    window.location.href = '//accounts.shopify.com/store-login';
  }
  return e;
});

export interface IRequest {
  success: boolean;
  data: any;
}
// TODO 待接口定义完成，添加

function errorHandle(error, block = true) {
  if (block) {
    message.error('网络出错，请检查网络');
  }
  return { success: false };
}

export const commonRequest = (
  apiUrl: string,
  options: {
    method: string;
    params?: {};
    data?: {};
    headers?: {};
    jsonp?: boolean;
  },
  needToken = true,
  block = true,
) => {
  if ((options.method === 'GET' || !options.method) && options.data) {
    options.params = options.data;
    options.data = null;
  }

  if (
    (options.method === 'POST' || options.method === 'PUT') &&
    !options.data &&
    options.params
  ) {
    options.data = options.params;
    options.params = null;
  }

  let headers = {};
  if (needToken) {
    const token = getCookie('shopify-sino-accessToken');
    if (token) {
      headers['X-Sino-Token'] = token;
    } else {
      // message.error('token已失效');
      delCookie('shopify-sino-accessToken');
      window.location.href = '//accounts.shopify.com/store-login';
    }
  }
  if (options && options.headers) {
    headers = { ...headers, ...options.headers };
  }

  const timeStamp = `_t=${new Date().getTime()}`;
  const url = apiUrl.replace(/(^\s*)|(\s*$)/g, '');
  const query = url.indexOf('?') >= 0 ? '&' : '?';

  if (options.jsonp) {
    const queryData = queryString.stringify(options.params);

    return jsonp(`${url}${query}${queryData}`)
      .then(response => response.json())
      .catch(error => {
        errorHandle(error);
      });
  }

  return Ajax({
    method: options.method || 'GET',
    url: encodeURI(`${url}${query}${timeStamp}`),
    data: options.data || {},
    params: options.params || {},
    headers,
  })
    .then(({ data }) => {
      console.log('data', data.success);
      if (data.success === undefined) {
        if (JSON.stringify(data.error) !== '[]') {
          const {
            error: { code },
          } = data;
          if (code === 'SHOIFY.LOGIN_EXPIRED') {
            delCookie('shopify-sino-accessToken');
            window.location.href = '//accounts.shopify.com/store-login';
          } else {
            return { data: data.error, success: false };
          }
        } else {
          return { data: data.result, success: true };
        }
      } else {
        if (data.success) {
          return { data: data.result, success: true };
        } else {
          message.error(data.message);
        }
      }
      let resp = {};
      //TODO 添加错误提示
      return { ...resp, success: false };
    })
    .catch(error => {
      return errorHandle(error, block);
    });
};

export const request = (
  url: string,
  options?: any,
  needToken?: boolean,
  block?: boolean,
) => {
  return commonRequest(url, options, needToken, block);
};
